// The dashboard module's entire public surface.
//
// Two exports and one stylesheet, following the engagement module's boundary
// (ADR-0016): nothing outside this folder imports from any other file in it,
// and nothing in here imports from `pages/`. Deleting the module is deleting
// the folder and two lines in App.tsx.
//
// Growing it is the opposite of that, and deliberately cheap: a new card is an
// entry in `cards.tsx` plus a key in `workspace_dashboard()`. No new route, no
// new request, and no change to the screen that lays them out.

import "./dashboard.css";

export { Dashboard } from "./Dashboard";
export type { Dashboard as DashboardData } from "./types";

/** Where the toolbar link points. Kept here so callers never hardcode it. */
export const DASHBOARD_ROUTE = "/dashboard";
